import mastercardLogo from "../../../assets/mastercard-logo.webp";
import visaLogo from "../../../assets/visa-logo.webp";

export const CARD_ICONS = {
  mastercard: mastercardLogo,
  visa: visaLogo,
};
